import {
  resetConfirmationStatus,
  setCloseConfirmationStatus,
} from "common/store/closeConfirmationStatusSlice";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";

const useCloseConfirmationStatus = () => {
  const dispatch = useAppDispatch();
  const { isDirty, closeConfirmationStatus } = useAppSelector(
    (state) => state.common.closeConfirmationStatus
  );

  const setIsDirty = useCallback(
    (isDirty: boolean) => {
      dispatch(setCloseConfirmationStatus({ isDirty }));
    },
    [dispatch]
  );

  const setConfirmationRequested = useCallback(() => {
    dispatch(
      setCloseConfirmationStatus({
        closeConfirmationStatus: "confirmationRequested",
      })
    );
  }, [dispatch]);

  const setCloseConfirmed = useCallback(() => {
    dispatch(
      setCloseConfirmationStatus({
        closeConfirmationStatus: "closeConfirmed",
      })
    );
  }, [dispatch]);

  const resetCloseConfirmationStatus = useCallback(() => {
    dispatch(
      setCloseConfirmationStatus({ closeConfirmationStatus: undefined })
    );
  }, [dispatch]);

  const resetConfirmationModalOpen = useCallback(() => {
    dispatch(resetConfirmationStatus());
  }, [dispatch]);

  return {
    isDirty,
    closeConfirmationStatus,
    setIsDirty,
    setConfirmationRequested,
    setCloseConfirmed,
    resetConfirmationModalOpen,
    resetCloseConfirmationStatus,
  };
};

export default useCloseConfirmationStatus;
